<template>
  <ul>
    <li><v-icon icon="fa-solid fa-arrow-up-right-dots" /> - Высокий приоритет</li>
    <br>
    <li><v-icon icon="fa-solid fa-triangle-exclamation" /> - Инцидент (аварийное обращение)</li>
    <li><v-icon icon="fa-solid fa-toolbox" /> - Заявка на дополнительные / прочие работы</li>
    <li><v-icon icon="fa-solid fa-chalkboard-user" /> - Заявка на отчет, инструктаж, помощь</li>
    <li><v-icon icon="fa-solid fa-helmet-safety" /> - Заявка на СМР / ПНР</li>
    <li><v-icon icon="fa-solid fa-hand-holding-hand" /> - Заявка на доп.испытание</li>
    <li><v-icon icon="fa-solid fa-hand-holding-medical" /> - Заявка на доп.техническое обслуживание</li>
    <br>
    <li><v-icon icon="fa-solid fa-circle-notch" /> - Другие обращения</li>
  </ul>
</template>

<script>
export default {
  name: "IconLegend"
}
</script>